module.exports = __webpack_public_path__ + "img/violet_009.d8e66137.png";